export const VideoCategoryGridSkeleton = () => (
  <div className="animate-pulse">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-[15px]">
      {Array.from({ length: 4 }).map((_, idx) => (
        <div key={idx} className="flex flex-col">
          <div className="relative w-full">
            <div className="w-full sm:h-[182px] h-[257px] rounded bg-neutral-200" />
          </div>
          <div className="mt-[15px] flex flex-col sm:gap-2.5">
            <div className="h-5 sm:h-6 w-full rounded bg-neutral-200" />
            <div className="h-3 sm:h-4 w-2/3 rounded bg-neutral-200" />
          </div>
        </div>
      ))}
    </div>
  </div>
)
